import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm border-t border-gray-800" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <p className="mb-6 text-gray-500" data-id="element-77">
          &copy; {new Date().getFullYear()} El Código del Metabolismo
          Silencioso. Todos los derechos reservados.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-8" data-id="element-78">
          <button onClick={() => setOpenModal('terms')} className="hover:text-white transition-colors underline decoration-gray-700 hover:decoration-white underline-offset-4" data-id="element-79">
            Términos y Condiciones
          </button>
          <button onClick={() => setOpenModal('privacy')} className="hover:text-white transition-colors underline decoration-gray-700 hover:decoration-white underline-offset-4" data-id="element-80">
            Política de Privacidad
          </button>
        </div>

        <p className="mt-8 text-xs text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-81">
          Descargo de responsabilidad: Este producto no sustituye el
          asesoramiento médico profesional. Consulte siempre a un médico para
          cualquier asunto relacionado con su salud. Los resultados pueden
          variar de una persona a otra.
        </p>
      </div>

      {/* Modal Overlay */}
      {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-82">
          <div className="bg-white text-gray-900 rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col relative animate-in zoom-in-95 duration-200" role="dialog" aria-modal="true" data-id="element-83">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-84">
              <h3 className="text-xl font-bold font-heading text-purple-900" data-id="element-85">
                {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={closeModal} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500 hover:text-gray-900" aria-label="Cerrar" data-id="element-86">
                <XIcon className="h-6 w-6" data-id="element-87" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 md:p-8 overflow-y-auto text-left space-y-4 leading-relaxed text-gray-600 custom-scrollbar" data-id="element-88">
              {openModal === 'privacy' ? <>
                  <p data-id="element-89">
                    <strong data-id="element-90">
                      Última actualización: {new Date().toLocaleDateString()}
                    </strong>
                  </p>
                  <p data-id="element-91">
                    En El Código del Metabolismo Silencioso, respetamos su
                    privacidad y estamos comprometidos a protegerla mediante el
                    cumplimiento de esta política.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-92">
                    1. Recopilación de información
                  </h4>
                  <p data-id="element-93">
                    Recopilamos información que usted nos proporciona
                    directamente cuando realiza una compra, se suscribe a
                    nuestro boletín o se comunica con nosotros. Esto puede
                    incluir su nombre, dirección de correo electrónico y
                    detalles de pago.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-94">
                    2. Uso de la información
                  </h4>
                  <p data-id="element-95">
                    Utilizamos la información recopilada para procesar sus
                    transacciones, enviarle el producto digital, proporcionarle
                    soporte al cliente y enviarle actualizaciones sobre nuestros
                    productos y servicios.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-96">
                    3. Protección de datos
                  </h4>
                  <p data-id="element-97">
                    Implementamos medidas de seguridad diseñadas para proteger
                    su información personal contra el acceso no autorizado y el
                    uso indebido. Sin embargo, ninguna transmisión de datos por
                    Internet es 100% segura.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-98">
                    4. Cookies
                  </h4>
                  <p data-id="element-99">
                    Utilizamos cookies para mejorar su experiencia en nuestro
                    sitio web. Puede configurar su navegador para rechazar todas
                    o algunas cookies.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-100">
                    5. Contacto
                  </h4>
                  <p data-id="element-101">
                    Si tiene preguntas sobre esta política de privacidad, por
                    favor contáctenos a través de los canales oficiales
                    proporcionados en la plataforma de pago.
                  </p>
                </> : <>
                  <p data-id="element-102">
                    <strong data-id="element-103">
                      Última actualización: {new Date().toLocaleDateString()}
                    </strong>
                  </p>
                  <p data-id="element-104">
                    Por favor, lea estos términos y condiciones cuidadosamente
                    antes de utilizar nuestro sitio web y comprar nuestros
                    productos.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-105">
                    1. Aceptación de los términos
                  </h4>
                  <p data-id="element-106">
                    Al acceder a este sitio web y comprar nuestros productos,
                    usted acepta estar sujeto a estos términos y condiciones.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-107">
                    2. Propiedad Intelectual
                  </h4>
                  <p data-id="element-108">
                    El contenido de este sitio web y el producto "El Código del
                    Metabolismo Silencioso" están protegidos por derechos de
                    autor. No está permitida la reproducción, distribución o
                    venta no autorizada de este material.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-109">
                    3. Uso del producto
                  </h4>
                  <p data-id="element-110">
                    Este producto es para uso personal y no comercial. No debe
                    compartir, revender ni distribuir el contenido digital.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-111">
                    4. Descargo de responsabilidad médica
                  </h4>
                  <p data-id="element-112">
                    El contenido proporcionado es solo para fines informativos y
                    educativos. No sustituye el consejo médico profesional.
                    Consulte siempre a su médico antes de comenzar cualquier
                    programa de salud o ejercicio.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-113">
                    5. Política de reembolso
                  </h4>
                  <p data-id="element-114">
                    Debido a la naturaleza digital del producto, todas las
                    ventas son finales, salvo que se indique lo contrario en una
                    garantía específica de satisfacción.
                  </p>
                  <h4 className="text-lg font-bold text-gray-900 mt-4" data-id="element-115">
                    6. Modificaciones
                  </h4>
                  <p data-id="element-116">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios entrarán en vigor
                    inmediatamente después de su publicación en el sitio web.
                  </p>
                </>}
            </div>

            {/* Modal Footer */}
            <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex justify-end" data-id="element-117">
              <button onClick={closeModal} className="px-6 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium text-sm" data-id="element-118">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}